/** Долгое нажатие 480 мс (стандарт жестов A43) — для блоков дашборда ОО (10.10: открыть окно
 *  «Проверка допработ за период»). Короткий тап живёт своей жизнью (onClick детей); после
 *  срабатывания следующий клик поглощается, чтобы отпускание пальца не нажало кнопку строки. */
import { useRef, type MouseEvent as ReactMouseEvent } from "react";

export function useLongPress(cb: () => void, ms = 480) {
  const timer = useRef<number | null>(null);
  const fired = useRef(false);
  const clear = () => { if (timer.current != null) { window.clearTimeout(timer.current); timer.current = null; } };
  return {
    onPointerDown: () => { clear(); fired.current = false; timer.current = window.setTimeout(() => { timer.current = null; fired.current = true; cb(); }, ms); },
    onPointerUp: clear,
    onPointerLeave: clear,
    onPointerCancel: clear,
    onContextMenu: (e: ReactMouseEvent) => { if (timer.current != null || fired.current) e.preventDefault(); },
    onClickCapture: (e: ReactMouseEvent) => { if (fired.current) { fired.current = false; e.stopPropagation(); e.preventDefault(); } },
  };
}
